export default {
	setPayments(state, value) {
		state.payments = value;
	},
	deletePayment(state, value) {
		let index = state.payments.findIndex(payment => payment._id == value);
		state.payments.splice(index, 1);
	},
	setMessage(state, value) {
		state.message = value;
		setTimeout(() => {
			state.message = '';
		}, 300);
	},
	setLoading(state, value) {
		state.loading = value;
	},
	setLoadingSave(state, value) {
		state.loadingSave = value;
	},
};
